import { env } from '../utils';

export const spmLog = (spmInfo) => {
  try {
    if (!env.isProd()) {
      return;
    }
    if (!spmInfo || !spmInfo.spmb) return;
    if (window.goldlog && window.goldlog.setPageSPM && window.goldlog.sendPV) {
      // 改变页面spmb的值
      // window.goldlog.setPageSPM('a2obl', spmInfo.spmb);
      window.goldlog.setPageSPM('a2oqv', spmInfo.spmb);
      // 发送pv统计信息
      window.goldlog.sendPV();
    }
  } catch (e) {
    console.error('gold not defined');
  }
};

export const sendGoldlog = (goldlogInfo, goKeys) => {
  // goKeys: {key: value, ...} 可选
  try {
    if (!env.isProd()) {
      return;
    }

    if (!goldlogInfo || goldlogInfo.length !== 4) return;
    if (window.goldlog && window.goldlog.record) {
      if (goKeys && Object.keys(goKeys).length > 0) {
        let goKey;
        for (let x in goKeys) {
          // 拼接goKey的kv字符串
          // 'example: key1=value&key2=value'
          !goKey ? goKey = `${x}=${goKeys[x]}` : goKey = `${goKey}&${x}=${goKeys[x]}`;
        }
        window.goldlog.record(goldlogInfo[0], goldlogInfo[1], goKey, goldlogInfo[3]);
      } else {
        window.goldlog.record(...goldlogInfo);
      }
    }
  } catch (e) {
    console.error('can not send gold log');
  }
};

export const SPM_LIST = {
  welcome: {
    spmb: '12584973',
    cliInfo: {
      NEW: {
        status: 'NEW',
        desc: 'banner开通',
      },
      WAITSIGN: {
        status: 'WAITSIGN',
        desc: '去签约',
      },
      REFRESH: {
        status: 'REFRESH',
        desc: '刷新',
      },
      NEW_BOTTOM: {
        status: 'NEW_BOTTOM',
        desc: '底部开通',
      },
    },
  },
  account: {
    // 入驻信息填写
    register: {
      spmb: '12584994',
      cliInfo: {
        GET_CODE: {
          status: 'GET_CODE',
          desc: '获取验证码',
        },
        NEXT: {
          status: 'NEXT',
          desc: '下一步',
        },
        CONFIRM: {
          status: 'CONFIRM',
          desc: '确认',
        },
        AUTHORIZE_FILE: {
          status: 'AUTHORIZE_FILE',
          desc: '上传授权及声明书',
        },
        LICENSE_FILE: {
          status: 'LICENSE_FILE',
          desc: '营业执照影印件查看',
        },
        ID_CARD_FRONT: {
          status: 'ID_CARD_FRONT',
          desc: '身份证正面查看',
        },
        ID_CARD_BACK: {
          status: 'ID_CARD_BACK',
          desc: '身份证反面查看',
        },
      },
    },
    // 入驻法人签约
    contract: {
      spmb: '12654660',
      cliInfo: {
        AGREEMENTS_No: {
          status: 'AGREEMENTS_NO',
          desc: '合同',
        },
      },
    },
    // 入驻提交审核
    finish: {
      spmb: '12654680',
    },
  },
  proceed: {
    list: {
      spmb: '12544844',
      cliInfo: {
        CONFIRM: {
          status: 'CONFIRM',
          desc: '提前收款',
        },
      },
    },
    records: {
      spmb: '12585177',
      cliInfo: {
        SEARCH: {
          status: 'SEARCH',
          desc: '查询',
        },
      },
    },
    qa: {
      spmb: '12585185',
    },
    personal: {
      spmb: '12585183',
      cliInfo: {
        LICENSE_FILE: {
          status: 'LICENSE_FILE',
          desc: '营业执照影印件查看',
        },
        ID_CARD_FRONT: {
          status: 'ID_CARD_FRONT',
          desc: '身份证正面查看',
        },
        ID_CARD_BACK: {
          status: 'ID_CARD_BACK',
          desc: '身份证反面查看',
        },
        AUTHORIZE_FILE: {
          status: 'AUTHORIZE_FILE',
          desc: '授权及声明书查看',
        },
      },
    },
    confirm: {
      spmb: '12585213',
      cliInfo: {
        GET_CODE: {
          status: 'GET_CODE',
          desc: '获取短信验证码',
        },
        CONFIRM: {
          status: 'CONFIRM',
          desc: '确认提前收款',
        },
        CONTINUE: {
          status: 'CONTINUE',
          desc: '继续提前收款',
        },
        RECORDS: {
          status: 'RECORDS',
          desc: '查看收款记录',
        },
      },
    },
    contract: {
      spmb: '12585217',
      cliInfo: {
        AGREEMENTS_No: {
          status: 'AGREEMENTS_NO',
          desc: '合同',
        },
      },
    },
    detail: {
      spmb: '12630092',
      cliInfo: {
        AGREEMENTS_No: {
          status: 'AGREEMENTS_NO',
          desc: '合同',
        },
        WAITSIGN: {
          status: 'WAITSIGN',
          desc: '去签约',
        },
      },
    },
  },
};





// WEBPACK FOOTER //
// ./src/utils/spm.js